export const stateOptions = [{
    label: 'QLD', value: 'QLD'
}, {
    label: 'NSW', value: 'NSW'
}];

export const allStateOptions = [
    { label: 'QLD', value: 'QLD'}, 
    { label: 'NSW', value: 'NSW'},
    { label: 'VIC', value: 'VIC'},
    { label: 'SA', value: 'SA'},
    { label: 'WA', value: 'WA'},
    { label: 'TAS', value: 'TAS'},
    { label: 'NT', value: 'NT'},
    { label: 'ACT', value: 'ACT'},
];

// TODO: Move to fetch from API
export const qldBrandOptions = [
    { value: 'BCS Strata Brisbane', label: 'BCS Strata Brisbane', eway_group: 'SEVEN' },
    { value: 'BCS Strata Cairns', label: 'BCS Strata Cairns', eway_group: 'SEVEN' },
    { value: 'BCS Strata Sunshine Coast', label: 'BCS Strata Sunshine Coast', eway_group: 'SEVEN' },
    { value: 'BCS Strata Mackay', label: 'BCS Strata Mackay', eway_group: 'SEVEN' },
    { value: 'BCS Strata Port Douglas', label: 'BCS Strata Port Douglas', eway_group: 'SEVEN' },
    { value: 'BCS Strata Southport', label: 'BCS Strata Southport', eway_group: 'SEVEN' },
    { value: 'BCS Strata Townsville', label: 'BCS Strata Townsville', eway_group: 'SEVEN' },
    { value: 'BCS Strata Coolangatta & Tweed Heads', label: 'BCS Strata Coolangatta & Tweed Heads', eway_group: 'SEVEN' },
    { value: 'QBS Strata Management', label: 'QBS Strata Management', eway_group: 'X' },
];

export const nswBrandOptions = [
    { value: 'BCS Strata North Shore (formerly Chatswood)', label: 'BCS Strata North Shore (formerly Chatswood)', eway_group: 'TWO' },
    { value: 'BCS Strata North Shore (formerly Epping)', label: 'BCS Strata North Shore (formerly Epping)', eway_group: 'TWO' },
    { value: 'BCS Strata Northern Beaches', label: 'BCS Strata Northern Beaches', eway_group: 'TWO' },
    { value: 'BCS Strata Southwest', label: 'BCS Strata Southwest', eway_group: 'TWO' },
    { value: 'BCS Strata Illawarra (formerly Wollongong)', label: 'BCS Strata Illawarra (formerly Wollongong)', eway_group: 'TWO' },
    { value: 'BCS Strata Gosford', label: 'BCS Strata Gosford', eway_group: 'TWO' },
    { value: 'BCS Strata Nelson Bay', label: 'BCS Strata Nelson Bay', eway_group: 'TWO' },
    { value: 'BCS Strata Newcastle', label: 'BCS Strata Newcastle', eway_group: 'TWO' },
    { value: 'BCS Strata Sydney', label: 'BCS Strata Sydney', eway_group: 'TWO' },
    { value: 'BCS Strata Tuncurry/Forster', label: 'BCS Strata Tuncurry/Forster', eway_group: 'TWO' },
    { value: 'BCS Strata Tweed Heads & Coolangatta', label: 'BCS Strata Tweed Heads & Coolangatta', eway_group: 'TWO' },
    { value: 'All Strata Services (Tuggerah)', label: 'All Strata Services (Tuggerah)', eway_group: 'ONE' },
    { value: 'GK Strata Management', label: 'GK Strata Management', eway_group: 'EIGHT' },
    { value: 'Mason & Brophy Strata Management', label: 'Mason & Brophy Strata Management', eway_group: 'THREE' },
    { value: 'NSW Strata Management', label: 'NSW Strata Management', eway_group: 'FOUR' },
    { value: 'QBS Strata Management', label: 'QBS Strata Management', eway_group: 'X' },
    { value: 'Robinson Strata Management', label: 'Robinson Strata Management', eway_group: 'FIVE' },
    { value: 'Somerville Strata Management', label: 'Somerville Strata Management', eway_group: 'SIX' },
    { value: 'Dynamic Property Services', label: 'Dynamic Property Services', eway_group: 'X' },
    { value: 'Sydney Company Title Management', label: 'Sydney Company Title Management', eway_group: 'X' },
];


// Moved to backend and into a table
// export const nswStatusToRecordsOptions = [
//     { value: "Lot owner", label: 'Lot owner', cost: 3410 },
//     { value: 'Prospective lot buyer', label: 'Prospective lot buyer', cost: 3410 },
//     { value: 'Agent appointed by the requestor', label: 'Agent appointed by the requestor', cost: 3410 },
//     { value: 'Another person with a proper interest in the information sought', label: 'Another person with a proper interest in the information sought', cost: 3410 },
// ];

// export const qldStatusToRecordsOptions = [
//     { value: "Lot owner", label: 'Lot owner', cost: 1935 },
//     { value: 'Prospective lot buyer', label: 'Prospective lot buyer', cost: 3720 },
//     { value: 'Agent appointed by the requestor', label: 'Agent appointed by the requestor', cost: 3720 },
//     { value: 'Lot owner in another body corporate in the same layered scheme', label: 'Lot owner in another body corporate in the same layered scheme', cost: 1935 },
//     { value: 'Body corporate in the same layered scheme', label: 'Body corporate in the same layered scheme', cost: 1935 },
//     { value: 'Not an owner or body corporate in the same layered scheme', label: 'Not an owner or body corporate in the same layered scheme', cost: 3720 },
// ];